<template>
  <section>
    <transition name="fade">
      <b-img
        v-if="exists"
        :src="imageLink"
        fluid-grow
        class="h-100 fit-image top-image"
      />
    </transition>
    <b-img
      src="@/assets/images/product-image-not-found.jpg"
      fluid-grow
      class="h-100 fit-image forced-top-left-placement"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "product-image",
  components: {},
  data() {
    return {
      exists: false
    };
  },
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink"
    })
  },
  created() {
    if (!this.imageLink) {
      return;
    }

    let downloadedImg = new Image();
    downloadedImg.addEventListener("load", this.imageReceived, false);
    downloadedImg.src = this.imageLink;
  },
  methods: {
    imageReceived() {
      this.exists = true;
    }
  }
};
</script>

<style>
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}

.top-image {
  z-index: 2;
  position: relative;
}

.forced-top-left-placement {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
